import {
  createApolloClient,
  getKraxiClientConfigPreset,
  gql,
  useKraxiQuery,
} from "@origin-digital/kraxi";
import { config } from "../../config";
import { AccountDetails } from "./graphql-types/AccountDetails";

export const krakenClient = createApolloClient(
  getKraxiClientConfigPreset("kraken", config.env)
);

export const krakenAccountDetailsQuery = gql`
  query AccountDetails {
    viewer {
      fullName
      email
      mobile
      dateOfBirth
      landline
      accounts {
        number
        billingAddress
        billingAddressLine1
        billingAddressLine2
        billingAddressLine3
        billingAddressLine4
        billingAddressLine5
        billingAddressPostcode
        billingCountryCode
        billingDeliveryPointIdentifier
        accountType
        ... on AccountType {
          accountType
          business {
            name
            number
          }
          commsDeliveryPreference
          properties {
            address
          }
          agreements(active: true) {
            supplyType
          }
        }
      }
    }
  }
`;

export const useKrakenAccountDetails = () =>
  useKraxiQuery<AccountDetails>(krakenAccountDetailsQuery, {
    client: krakenClient,
  });
